
import React from 'react'

import ToggleNotifications from './ToggleNotifications'
import HeaderChatMenu from './HeaderChatMenu'
import HeaderSubmenuItem from './HeaderSubmenuItem'

import './HeaderSubMenu.scss'

interface Props {
  submenu: any
  projectName?: string
}

const HeaderSubMenu = ({ submenu, projectName }: Props) => {

  return (
    <>
      <div className="horizontal-bar-wrap">
        <div className="header-topnav">
          <div className="submenu-bar">
            {submenu.length > 0 && (
              <div className="submenu-left">
                <ul className="submenu submenu-left">
                  {submenu.map((item: any, i: number) => (
                    <HeaderSubmenuItem
                      key={i}
                      active={item.active}
                      disabled={item.disabled}
                      icon={item.icon}
                      text={item.text}
                      path={item.path}
                    />
                  ))}
                </ul>
              </div>
            )}
            <div className="submenu-right">
              {projectName && (
                <div className={`subtitle${''}`}>
                  {projectName}
                </div>
              )}
              <div className="header-dropdowns">
                <ToggleNotifications />
                <HeaderChatMenu />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderSubMenu
